import { render, staticRenderFns } from "./RequisitoCard.vue?vue&type=template&id=c654a452&"
import script from "./RequisitoCard.vue?vue&type=script&lang=js&"
export * from "./RequisitoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports